// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_5m-4";
export var collapsed = "_5m-1";
export var headerBar = "_5m-0";
export var leftHeaderContent = "_5m-3";
export var subjectContainer = "_5m-2";